import type { ReactElement } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from '../../../../ui-components';
import type { Attendee as AttendeeModel } from '../../models/Attendee';

export interface AttendeeProps {
    attendee: AttendeeModel;
    index: number;
    onEdit: (id: string, index: number) => void;
    onDelete: (id: string) => void;
    numberOfAttendees: number;
    showButtons: boolean;
}

export const Attendee = ({
    attendee: { id, fname, lname },
    index,
    onEdit,
    onDelete,
    numberOfAttendees,
    showButtons,
}: AttendeeProps): ReactElement => (
    <Flex data-testid={`attendee-${id}`} direction="column" gap={1}>
        <Text id={`attendee-title-${id}`} style="bold">
            <FormattedMessage
                defaultMessage="Attendee #{index}"
                id="cart.culinary-item.attendee-title"
                values={{ index: index + 1 }}
            />
        </Text>

        <Flex justify="space-between" width="100%">
            <Text id={`attendee-name-${id}`}>{`${fname} ${lname}`}</Text>

            {showButtons ? (
                <Flex gap={2}>
                    <Button
                        textSize="base"
                        variant="text-button"
                        padding="0"
                        onClick={() => onEdit(id ?? '', index + 1)}
                        id={`attendee-edit-button-${id}`}
                    >
                        <FormattedMessage
                            id="cart.culinary-item.edit-attendee"
                            defaultMessage="Edit"
                        />
                    </Button>

                    {numberOfAttendees > 1 && (
                        <>
                            <Text>|</Text>
                            <Button
                                textSize="base"
                                variant="text-button"
                                padding="0"
                                onClick={() => onDelete(id ?? '')}
                                id={`attendee-delete-button-${id}`}
                            >
                                <FormattedMessage
                                    id="cart.culinary-item.delete-attendee"
                                    defaultMessage="Delete"
                                />
                            </Button>
                        </>
                    )}
                </Flex>
            ) : null}
        </Flex>
    </Flex>
);
